import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { ROUTE_PATH } from '../../../../config/paths';
import RouteDeleteButton from './RouteDeleteButton';
import CloneRouteButton from './CloneRouteButton';
import RouteActiveButton from './RouteActiveButton';

const RouteToolbar = ({ routeId, active }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <RouteActiveButton routeId={routeId} active={active}/> {' '}
      <EditButton path={`${ROUTE_PATH}/${routeId}/edit`} />{' '}
      <CloneRouteButton routeId={routeId} />{' '}
      <RouteDeleteButton routeId={routeId} />
    </div>
  </ButtonToolbar>
);

RouteToolbar.propTypes = {
  routeId: PropTypes.number.isRequired,
    active: PropTypes.bool.isRequired,
};

export default RouteToolbar;
